// back-to-top.js
(function() {
  // 创建按钮元素
  const btn = document.createElement('div');
  btn.id = 'custom-back-to-top';
  // 使用 SVG 箭头图标
  btn.innerHTML = `
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <polyline points="18 15 12 9 6 15"></polyline>
    </svg>
  `;
  document.body.appendChild(btn);

  // 显示/隐藏逻辑
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    if (window.scrollY > 300) {
      btn.style.display = 'flex';
    } else {
      btn.style.display = 'none';
    }
  });

  // 点击平滑回到顶部
  btn.addEventListener('click', function(e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  // 定位函数：将按钮放在 Inbox 悬浮窗的正上方
  function positionButton() {
    // 查找 Inbox 容器（常见的几种选择器）
    const inbox = document.querySelector(
      '#shopify-chat, .shopify-chat, [id*="shopify-chat"], [class*="shopify-chat"]'
    );

    if (inbox && inbox.getBoundingClientRect().height > 0) {
      const rect = inbox.getBoundingClientRect();
      const spacing = 12;          // 按钮与 Inbox 之间的间距（px）
      const btnHeight = 44;        // 按钮高度，与 CSS 中一致

      // 计算按钮 bottom 值：按钮底部位于 Inbox 顶部上方 spacing 处
      const buttonBottomOffset = rect.top - spacing;
      let bottomVal = window.innerHeight - buttonBottomOffset;

      // 如果计算结果不合理（例如超出视口），则回退到固定值
      if (bottomVal < 0 || buttonBottomOffset <= 0) {
        bottomVal = 80;
      }
      btn.style.bottom = bottomVal + 'px';

      // 与 Inbox 右对齐
      const rightOffset = window.innerWidth - rect.right;
      btn.style.right = rightOffset + 'px';
    } else {
      // 未找到 Inbox 时使用默认右下角位置
      btn.style.bottom = '80px';
      btn.style.right = '20px';
    }
  }

  // 初始化定位，并监听窗口大小变化
  positionButton();
  window.addEventListener('resize', positionButton);

  // 由于 Inbox 可能延迟加载，使用 MutationObserver 监视 DOM 变化
  const observer = new MutationObserver(function(mutations) {
    if (document.querySelector('#shopify-chat, .shopify-chat, [id*="shopify-chat"], [class*="shopify-chat"]')) {
      positionButton();
      observer.disconnect(); // 找到后停止观察，避免性能浪费
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // 额外延迟调用几次，确保 Inbox 完全加载后重新定位
  setTimeout(positionButton, 1000);
  setTimeout(positionButton, 3000);
})();